import styled from 'styled-components';
import { FormGroup } from '../style';

export const FlexRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const FlexFormGroup = styled(FormGroup)<{ flex?: string }>`
  flex: ${props => props.flex || '1'};
`;

export const SortableItemContainer = styled.div<{ isDragging?: boolean }>`
  opacity: ${props => props.isDragging ? 0.5 : 1};
`;

export const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: grab;
  flex: 1;
`;

export const DragHandle = styled.div`
  cursor: grab;
`;

export const ItemTitle = styled.span`
  font-weight: bold;
  font-size: 16px;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #F87171;
  padding: 4px;
`;

export const ScriptSelectContainer = styled.div`
  position: relative;
`;

export const CollapsedItem = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CollapsedItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: grab;
  flex: 1;
`;

export const CollapsedItemControls = styled.div`
  display: flex;
  gap: 8px;
`;

export const CircularCollapseIcon = styled.button`
  background: #f0f0f0;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: #e0e0e0;
  }
`;
